module.exports = __webpack_public_path__ + "static/media/logo-big.c07caf03.svg";